import { createContext, useState } from "react";
import { ContextProviderProps } from "../../../types";
import {
  ExciseLicencesState,
  IDozvolaInformacijeProps,
  ISkladisteInformacijeProps,
  UpdateInformationLicenceFunction,
  UpdateInformationWarehouseFunction,
  UpdateLicencesFunction,
} from "./exciseLicences.types";

import cloneDeep from "lodash.clonedeep";

export const initialState = (): ExciseLicencesState => {
  return {
    //Response for inicijalniPodaciDozvoleDrustva

    kategorijaProizvoda: [],

    //Response for vracanjeDodatnihInformacijaZaKreiranjeDozvole
    tipDozvole: null,
    dozvolaInformacijeSkladista: {
      evidencioniBroj: "",
      kategorijaProizvodaId: null,
      ulicaProizvodnje: "",
      brojUliceProizvodnje: "",
      postanskiBrojProizvodnje: "",
      mestoProizvodnje: "",
      kolicinaUskladistenihProizvoda: null,
      prosecanMesecniRashod: null,
      nacinOtpremanja: "",
      podatakOMernimUredjajima: "",
      brojResenja: "",
      datumResenjaNadleznogOrgana: "",
      datumResenjaNadleznogOrganaPrikaz: "",
      tarifnaOznaka: "",
      kolicinaPojedinacnihPakovanjaKomadi: null,
      kolicinaDuvanaKg: null,
      prosecnaKolicinaPojedinacnihPakovanjaKomadi: null,
      prosecnaKolicinaDuvanaKg: null,
    },
    userInformationDozvola: {
      akcizniProizvod: [],
      id: null,
      naziv: "",
      imeGrada: "",
      pib: "",
      preteznaDelatnost: "",
    },
    skladisteInformacije: [],
    mereVelicine: [],
    dokumentiZaDozvoluSkladista: [],

    //Response for kreiranjeZahtevaDozvole

    data: null,

    //Payload for kreiranjeZahtevaDozvole

    dokumentiZaDozvolu: [],
    dozvolaInformacije: {
      tarifnaOznaka: "",
      kategorijaProizvodaId: null,
      ulicaProizvodnje: "",
      brojUliceProizvodnje: "",
      postanskiBrojProizvodnje: "",
      mestoProizvodnje: "",
      nacinOtpremanja: "",
      podatakOMernimUredjajima: "",
      brojResenja: "",
      datumResenjaNadleznogOrgana: null,
      kolicinaUskladistenihProizvoda: null,
      kolicinaDuvanaKg: null,
      kolicinaPojedinacnihPakovanjaKomadi: null,
      prosecanMesecniRashod: null,
      prosecnaKolicinaDuvanaKg: null,
      prosecnaKolicinaPojedinacnihPakovanjaKomadi: null,
    },
    skladisteInformacijePayload: {
      skladisteId: null,
      kolicinaProizvodaIzPrethodneGodine: null,
      kolicinaProizvodaIzPrethodneGodineKg: null,
      kolicinaProizvodaIzPrethodneGodineKomadi: null,
      planiranaProizvodnjaProizvoda: null,
      planiranaProizvodnjaProizvodaKg: null,
      planiranaProizvodnjaProizvodaKomadi: null,
      brojSkladistaZaDozvolu: "",
      ulicaSkladista: "",
      brojUliceSkladista: "",
      postanskiBrojSkladista: "",
      mestoSkladista: "",
      oznakaSkladista: "",
      opisSkladista: "",
      opisRadaRacunovodstva: "",
      meraVelicineSkladista: null,
      meraVrednost: null,
    },

    //Selected

    selectedDozvolaId: null,
    selectedSkladisteId: null,
  };
};

interface IExciseLicencesContext {
  exciseLicences: ExciseLicencesState;
  setExciseLicences: UpdateLicencesFunction;
  setInformacijeDozvole: UpdateInformationLicenceFunction;
  setInformacijeSkladista: UpdateInformationWarehouseFunction;
  clearLicencesState: () => void;
  clearPayloadState: () => void;
}

export const ExciseLicencesContext = createContext<IExciseLicencesContext>(
  null as any
);

export const ExciseLicencesContextProvider = ({
  children,
}: ContextProviderProps) => {
  const [exciseLicences, setExciseLicencesState] = useState(initialState());

  const handleSetLicences = (updatedState: Partial<ExciseLicencesState>) => {
    setExciseLicencesState((prev) => ({ ...prev, ...updatedState }));
  };

  const setExciseLicences = (updatedState: Partial<ExciseLicencesState>) => {
    handleSetLicences({ ...updatedState });
  };

  const clearLicencesState = () => {
    setExciseLicencesState(initialState());
  };

  const clearPayloadState = () => {
    const updatedState: Partial<ExciseLicencesState> = {
      tipDozvole: null,
      dokumentiZaDozvolu: [],
      dokumentiZaDozvoluSkladista: [],
      dozvolaInformacije: {
        tarifnaOznaka: "",
        kategorijaProizvodaId: null,
        ulicaProizvodnje: "",
        brojUliceProizvodnje: "",
        postanskiBrojProizvodnje: "",
        mestoProizvodnje: "",
        nacinOtpremanja: "",
        podatakOMernimUredjajima: "",
        brojResenja: "",
        datumResenjaNadleznogOrgana: null,
        kolicinaUskladistenihProizvoda: null,
        kolicinaDuvanaKg: null,
        kolicinaPojedinacnihPakovanjaKomadi: null,
        prosecanMesecniRashod: null,
        prosecnaKolicinaDuvanaKg: null,
        prosecnaKolicinaPojedinacnihPakovanjaKomadi: null,
      },
      skladisteInformacijePayload: {
        skladisteId: null,
        kolicinaProizvodaIzPrethodneGodine: null,
        kolicinaProizvodaIzPrethodneGodineKg: null,
        kolicinaProizvodaIzPrethodneGodineKomadi: null,
        planiranaProizvodnjaProizvoda: null,
        planiranaProizvodnjaProizvodaKg: null,
        planiranaProizvodnjaProizvodaKomadi: null,
        brojSkladistaZaDozvolu: "",
        ulicaSkladista: "",
        brojUliceSkladista: "",
        postanskiBrojSkladista: "",
        mestoSkladista: "",
        oznakaSkladista: "",
        opisSkladista: "",
        opisRadaRacunovodstva: "",
        meraVelicineSkladista: null,
        meraVrednost: null,
      },
      selectedSkladisteId: null,
    };
    setExciseLicences(updatedState);
  };

  const setInformacijeDozvole = (
    updatedState: Partial<IDozvolaInformacijeProps>
  ) => {
    const stateCopy = cloneDeep(exciseLicences);
    setExciseLicencesState({
      ...stateCopy,
      dozvolaInformacije: {
        ...stateCopy.dozvolaInformacije,
        ...updatedState,
      },
    });
  };

  const setInformacijeSkladista = (
    updatedState: Partial<ISkladisteInformacijeProps>
  ) => {
    const stateCopy = cloneDeep(exciseLicences);
    setExciseLicencesState({
      ...stateCopy,
      skladisteInformacijePayload: {
        ...stateCopy.skladisteInformacijePayload,
        ...updatedState,
      },
    });
  };

  return (
    <ExciseLicencesContext.Provider
      value={{
        exciseLicences,
        setExciseLicences,
        clearLicencesState,
        clearPayloadState,
        setInformacijeDozvole,
        setInformacijeSkladista,
      }}
    >
      {children}
    </ExciseLicencesContext.Provider>
  );
};
